import React, { Component } from 'react'

// style
import TopbarDropdownWrapper from './topbarDropDown.style'
import IntlMessages from '../../../components/utility/intlMessages'

// pop over
import Popover from '../../../components/uielements/popover'
import { palette } from 'styled-theme'

// redux
import { connect } from 'react-redux'
import authActions from '../../../redux/auth/actions'

// icon
import { FaUser, FaLock, FaSignOutAlt } from 'react-icons/fa'
import getFlag from './flags/getFlag'
import { BrowserRouter as Router, Route, Link } from 'react-router-dom'
import imageUrl from '../../../resource/image/defaultAvatar.png'
// sub component
import SelectLanguage from './selectLanguage'

class AvatarUser extends Component {
    constructor(props) {
        super(props)
        this.handleVisibleChange = this.handleVisibleChange.bind(this)
        this.hide = this.hide.bind(this)
        this.state = {
            visible: false,
        }
    }
    hide() {
        this.setState({ visible: false })
    }
    handleVisibleChange() {
        this.setState({ visible: !this.state.visible })
    }

    render() {
        const { userInfo, curLang } = this.props

        const content = (
            <TopbarDropdownWrapper className="isoUserDropdown">
                <div className="isoDisplayName">
                    <div>
                        <img
                            src={
                                userInfo && userInfo.avatar !== ''
                                    ? userInfo.avatar
                                    : imageUrl
                            }
                            style={{ height: 60, width: 60, borderRadius: 30 }}
                            alt="avatar"
                        />
                    </div>
                    <span style={{ marginLeft: 10 }}>
                        {userInfo ? userInfo.display_name : ''}
                    </span>
                </div>
                {/* <a className="isoDropdownLink">
                    <div>
                        <img
                            src={getFlag(curLang)}
                            style={{ height: 10, width: 13 }}
                            className="isoIcon"
                        />
                    </div>
                    <SelectLanguage />
                </a> */}
                <a className="isoDropdownLink">
                    <Link
                        to="/app/userinfo"
                        style={{
                            color: 'rgba(0, 0, 0, 0.65)',
                            textDecoration: 'none',
                            width: '100%',
                        }}
                    >
                        <FaUser className="isoIcon" />
                        <IntlMessages id="topbar.user_info" />
                    </Link>
                </a>
                <a className="isoDropdownLink">
                    <Link
                        to="/app/changepass"
                        style={{
                            color: 'rgba(0, 0, 0, 0.65)',
                            textDecoration: 'none',
                            width: '100%',
                        }}
                    >
                        <FaLock className="isoIcon" />
                        <IntlMessages id="topbar.change_password" />
                    </Link>
                </a>
                <a className="isoDropdownLink" onClick={this.props.logout}>
                    <FaSignOutAlt className="isoIcon" />
                    <IntlMessages id="topbar.logout" />
                </a>
            </TopbarDropdownWrapper>
        )

        return (
            <Popover
                content={content}
                trigger="click"
                visible={this.state.visible}
                onVisibleChange={this.handleVisibleChange}
                arrowPointAtCenter={true}
                placement="bottomLeft"
            >
                <img
                    src={
                        userInfo && userInfo.avatar !== ''
                            ? userInfo.avatar
                            : imageUrl
                    }
                    style={{ height: 45, width: 45, borderRadius: 22 }}
                    alt="avatar"
                />
            </Popover>
        )
    }
}

const mapStateToProps = state => {
    return {
        userInfo: state.auth.userInfo,
        curLang: state.language.lang,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        logout: () => {
            dispatch(authActions.action.logout())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AvatarUser)
